import EventReservationDetails from 'components/Content/Happening/ReservationDetails/EventDetails/EventDetails';
import { withHappeningDetailsProps } from 'viewModel/happening/withHappeningDetailsProps';
import { withEnsureUserIsSignedIn } from 'hocs/withEnsureUserIsSignedIn';

export default withEnsureUserIsSignedIn(withHappeningDetailsProps(EventReservationDetails));
